import React from 'react';
import {AssigneeModel} from '@/typings/models/Assignee';
import AgentInfoEdit from '@/components/AgentInfoEdit';

interface AgentGeneralInfoTabProps {
  agent: AssigneeModel;
  onDirty?: () => void;
}

const AgentGeneralInfoTab: React.FC<AgentGeneralInfoTabProps> = ({ agent, onDirty }) => <AgentInfoEdit agent={agent} type={'personal'} onDirty={onDirty} />

export default AgentGeneralInfoTab;
